export interface UploadSuccess {
  signedId: string
}
export interface UploadFailure {
  error: Error
}
export type UploadOutcome = UploadSuccess | UploadFailure

interface UploadEntry {
  promise: Promise<UploadOutcome>
  result?: UploadOutcome
}

// File-keyed (no manual cleanup needed - GC'd once the File is unreachable)
// so submit-time code can find the upload that already started silently at
// attach-time, rather than starting a redundant one. Storing the settled
// result alongside the promise lets that lookup be synchronous: "is this
// already done?" without racing the promise a second time.
const uploadsByFile = new WeakMap<File, UploadEntry>()

export const startBackgroundVideoUpload = (
  file: File,
  uploadFn: () => Promise<UploadOutcome>,
): UploadEntry => {
  const entry: UploadEntry = { promise: uploadFn() }
  entry.promise.then((outcome) => {
    entry.result = outcome
  })
  uploadsByFile.set(file, entry)
  return entry
}

export const getBackgroundVideoUpload = (file: File): UploadEntry | undefined =>
  uploadsByFile.get(file)
